/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateCimdOrganizationRemoteSessionClientForm,
  CreateCimdOrganizationRemoteSessionClientForm$Outbound,
  CreateCimdOrganizationRemoteSessionClientForm$outboundSchema,
} from "../components/createcimdorganizationremotesessionclientform.js";

export type CreateCimdOrganizationRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type CreateCimdOrganizationRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  createCimdOrganizationRemoteSessionClientForm:
    CreateCimdOrganizationRemoteSessionClientForm;
};

/** @internal */
export type CreateCimdOrganizationRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const CreateCimdOrganizationRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    CreateCimdOrganizationRemoteSessionClientSecurity$Outbound,
    CreateCimdOrganizationRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function createCimdOrganizationRemoteSessionClientSecurityToJSON(
  createCimdOrganizationRemoteSessionClientSecurity:
    CreateCimdOrganizationRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    CreateCimdOrganizationRemoteSessionClientSecurity$outboundSchema.parse(
      createCimdOrganizationRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type CreateCimdOrganizationRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  CreateCimdOrganizationRemoteSessionClientForm:
    CreateCimdOrganizationRemoteSessionClientForm$Outbound;
};

/** @internal */
export const CreateCimdOrganizationRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    CreateCimdOrganizationRemoteSessionClientRequest$Outbound,
    CreateCimdOrganizationRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      createCimdOrganizationRemoteSessionClientForm:
        CreateCimdOrganizationRemoteSessionClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        createCimdOrganizationRemoteSessionClientForm:
          "CreateCimdOrganizationRemoteSessionClientForm",
      });
    }),
  );

export function createCimdOrganizationRemoteSessionClientRequestToJSON(
  createCimdOrganizationRemoteSessionClientRequest:
    CreateCimdOrganizationRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    CreateCimdOrganizationRemoteSessionClientRequest$outboundSchema.parse(
      createCimdOrganizationRemoteSessionClientRequest,
    ),
  );
}
